export default __webpack_public_path__ + "static/stu-dixon-cbb280ad4e4c4731ee16e80b042236bf.png";